import React, { FC } from "react";
import { FlexContainer } from "../../../../common/components/FlexContainer/FlexContainer";
import { FlexItem } from "../../../../common/components/FlexItem/FlexItem";
import { Text, Image } from "@fluentui/react-components";

import "./Unauthorized.scss";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";

export const Unauthorized: FC<{}> = (props) => {

    return (
        <FlexContainer direction={"column"} alignItems={"center"} className="c-ohNo" >
            <Text size={900}>{localizedStrings.AdminView?.Unauthorized?.title}</Text>
            <Text size={400}>{localizedStrings.AdminView?.Unauthorized?.description}</Text> 
            <Image src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExdXlxendrN2EzNmtrZHVpMWZwczE0a2N3Nmhycjl0YTdqb2wzYXR5dSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/MfTW6bkRhvFzbAZO1p/giphy.gif"></Image>
        </FlexContainer>
    );
}